import $ from "jquery";
import type { ParamsObject, ParamValue } from "./apiUtils.dto";

const apiUtils = {
  buildParamsListURI(uri: string, params: ParamsObject): string {
    let paramStr = uri;
    $.each(params, function (key: string, values: ParamValue) {
      if (Array.isArray(values)) {
        $.each(values, function (idx: number, value: string | number) {
          paramStr += paramStr.indexOf("?") < 0 ? "?" : "&";
          paramStr += key + "=" + value;
        });
      } else if (values != null) {
        paramStr += paramStr.indexOf("?") < 0 ? "?" : "&";
        paramStr += key + "=" + values;
      }
    });

    return paramStr;
  },

  buildURIWithArray(uri: string, array: unknown[], paramName: string): string {
    let paramStr = uri;
    $.each(array, function (index: number, value: unknown) {
      paramStr += paramStr.indexOf("?") < 0 ? "?" : "&";
      paramStr += paramName + "=" + value;
    });

    return paramStr;
  },
};

export { apiUtils };
export default apiUtils;
